import Text from 'components/Text';
import { MAX_ORDER_GIRL, TEXT_STRING } from '../../constants';
import IconButton from 'components/IconButton';

const COMMON_STR = TEXT_STRING.COMMON;

type Props = {
  count: number;
  onMinus: () => void;
  onPlus: () => void;
  disabled?: boolean;
};

const CardRank = ({
  count = 0,
  onMinus,
  onPlus,
  disabled = false,
}: Props): JSX.Element => {
  return (
    <div className="w-full rounded-2xl border shadow-md">
      <div className="w-full flex justify-end items-end px-4 pt-10 pb-4">
        <div className="flex items-center gap-4">
          <IconButton
            onClick={onMinus}
            icon={'minusCircle'}
            transparent
            disabled={count <= 0}
          />
          <Text fontSize={18} bold>
            {count} {COMMON_STR.PEOPLE}
          </Text>
          <IconButton
            onClick={onPlus}
            icon={'plusCircle'}
            transparent
            disabled={disabled || count >= MAX_ORDER_GIRL}
          />
        </div>
      </div>
    </div>
  );
};

export default CardRank;
